import {
    WorkplaceArchiveApiV1AdjutantAppWorkplaceWorkplaceIdArchivePostParams,
    WorkplaceArchiveModel,
    WorkplaceCreateModel,
    WorkplaceDeleteApiV1AdjutantAppWorkplaceWorkplaceIdDeleteParams,
    WorkplaceDeleteOutputDTO,
    WorkplaceDetailApiV1AdjutantAppWorkplaceWorkplaceIdGetParams,
    WorkplaceDTO,
    WorkplaceListApiV1AdjutantAppWorkplaceGetParams,
    WorkplaceListOutputDTO,
    WorkplaceUpdateApiV1AdjutantAppWorkplaceWorkplaceIdPatchParams,
} from '../swagger/dto'
import { deleteRequest, getRequest, patchRequest, postRequest } from './config'
import { WORKPLACE_URL } from './endpoints.constants'

export const getProject = async (params: WorkplaceListApiV1AdjutantAppWorkplaceGetParams) => {
    const response = await getRequest<WorkplaceListOutputDTO>(WORKPLACE_URL, params)
    return response.data
}

export const getProjectDetail = async (
    params: WorkplaceDetailApiV1AdjutantAppWorkplaceWorkplaceIdGetParams,
) => {
    const response = await getRequest<WorkplaceDTO>(
        `${WORKPLACE_URL}/${params.workplaceId}`,
        params,
    )
    return response.data
}

export const createProject = async (data: WorkplaceCreateModel) => {
    const response = await postRequest<WorkplaceCreateModel, WorkplaceDTO>(WORKPLACE_URL, data)
    return response.data
}

export const patchProject = async (
    params: WorkplaceUpdateApiV1AdjutantAppWorkplaceWorkplaceIdPatchParams,
    payload: WorkplaceDTO,
) => {
    const response = await patchRequest<WorkplaceDTO>(
        `${WORKPLACE_URL}/${params.workplaceId}`,
        payload,
    )
    return response.data
}

export const deleteProject = async (
    params: WorkplaceDeleteApiV1AdjutantAppWorkplaceWorkplaceIdDeleteParams,
) => {
    const response = await deleteRequest<WorkplaceDeleteOutputDTO>(
        `${WORKPLACE_URL}/${params.workplaceId}`,
    )
    return response.data
}

export const archiveProject = async (
    params: WorkplaceArchiveApiV1AdjutantAppWorkplaceWorkplaceIdArchivePostParams,
    data: WorkplaceArchiveModel,
) => {
    const response = await postRequest<WorkplaceArchiveModel, WorkplaceDTO>(
        `${WORKPLACE_URL}/${params.workplaceId}/archive`,
        data,
    )
    return response.data
}
